module.exports = new __parcel__URL__("workflow-builder-splash.9f5889b8.svg").toString();